<mat-dialog-title fxLayout="row" fxLayoutAlign="space-between">
  <h2>{{ data?.title | translate }}</h2>
   <button class="clear-btn" mat-icon-button aria-label="Clear" (click)="close()">
    <mat-icon>clear</mat-icon>
  </button>
</mat-dialog-title>
<mat-dialog-content class="mat-typography">
  <div>
    <p> {{ data?.content | translate }}</p>
    <p class="note"> {{ data?.note | translate }}</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="accent" (click)="close()">{{
    (data.confirmButtonText || 'appSelectedAssetNavigation.close' )| translate }}</button>
</mat-dialog-actions>